import 'es6-promise/auto'
import '@/utils/configuration'
import Vue from 'vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import '@fortawesome/fontawesome-free-webfonts/css/fontawesome.css'
import '@fortawesome/fontawesome-free-webfonts/css/fa-regular.css'
import '@fortawesome/fontawesome-free-webfonts/css/fa-solid.css'
import '@fortawesome/fontawesome-free-webfonts/css/fa-brands.css'
import VeeValidate from 'vee-validate'
import '@/css/app.css'
import App from '@/App.vue'
import router from '@/router'
import '@/api'
import Multiselect from 'vue-multiselect'

Vue.component('multiselect', Multiselect)

Vue.filter('currency', function (value) {
  return parseFloat(value).toFixed(2);
})

Vue.use(Buefy, {
  defaultIconPack: 'fas'
})

Vue.use(VeeValidate, {
  events: ''
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
